import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import VendaModel from "@/models/vendaModel";
import ServicoEntregaService from "@/services/servicoEntregaService";

const servicoEntregaService = new ServicoEntregaService();

@Component({
    components: {
        comboComponent,
        shortcutComponent,
    },
})
export default class ServicoCorreioComponent extends Vue {
    private shortcutComponent: ShortcutComponent = null;
    etiqueta?: number = null;

    etiquetaOptions = [];

    public async show(vendas: VendaModel[]) {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;

        this.etiquetaOptions = await servicoEntregaService.listCorreios().resolveWithJSON<[]>();
        const venda = vendas.find(p => p.servicoEntregaId);
        if (venda) {
            this.etiqueta = venda.servicoEntregaId;
        }

        this.shortcutComponent.title = this.$t("__.Crud.etiquetas.servicoCorreio_vue_html.etiqueta") as string;

        this.shortcutComponent.show();
    }

    private async onConfirm() {
        this.$emit("onGerarCodigoRastreio", this.etiqueta.toString().padStart(5, "0"));
        this.shortcutComponent.hide();
    }
}
